import { MenuItem } from '@szhsin/react-menu';
import styled from 'styled-components';

import { Button, ButtonSize, ButtonVariant } from '../Button';

export const MenuButton = styled(Button).attrs({
    size: ButtonSize.SMALL,
    variant: ButtonVariant.SECONDARY,
    type: 'button',
})`
    font-weight: normal;

    & > svg {
        width: 0.375rem;
        fill: ${({ theme }) => theme.colors.formLabel};
    }
`;

export const StatusColor = styled.div<{ color: string }>`
    width: 0.625rem;
    height: 0.625rem;
    border-radius: 50%;
    background-color: ${({ color }) => color};
`;

export const StyledMenuItem = styled(MenuItem)`
    font-weight: normal;
    display: flex;
    align-items: center;
    margin: 0.625rem 0;

    & > ${StatusColor} {
        margin-right: 1rem;
    }
`;
